import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { StateService } from '../../services/state.service';

import { VerificationResponseDto } from '../../adapter/dto/verification-response.dto';

export const bewerbungEingereichtGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean | UrlTree => {
  const stateService: StateService = inject(StateService);
  const router: Router = inject(Router);
  const verifyResult: VerificationResponseDto | null = stateService.getVerificationResponse();
  const token: string | null = route.paramMap.get('token');

  if (verifyResult !== null && verifyResult.bewerbungsunterlagenVorhanden) {
    return router.createUrlTree(['/vp', token, 'bewerbung-eingereicht']);
  }
  return true;
};
